
export interface ExpensePolicyPerDiemClass {
    AccountExpensePolicyPerDiemId: number
    AccountExpensePolicyId: string
    AccountId: number
    DefaultExpenseCategoryPerDiemId: number
    IsDisabledPerDiem: boolean
    AccountExpensePolicyPerDiemLocationId: number
    PerDiemLocationName: string
    SystemCountryId: number
    SystemCityId: number
    EffectiveDate: Date | undefined
    IsDefaultRate: boolean
    SystemCurrencyId: number
    AccountExpensePolicyPerDiemLocationRateId: number
    AccountExpensePolicyPerDiemTypeId: number
    AccountExpensePolicyPerDiemTypeName: string
    PerDiemRate: number
    IsDefault: boolean
    AccountExpenseId: number
    AccountExpenseName: string
    AccountCurrencyId: number
    CurrencyCode: string
    CountryId: number
    Country: string
    CityId: number
    City: string
    isSelected: number
}

export interface ExpensePolicyPerDiemTypeClass {
    AccountExpensePolicyPerDiemTypeId: number
    AccountExpensePolicyPerDiemTypeName: string
    SystemCurrencyId: number
    CurrencyCode: string
    PerDiemRate: number
    AccountExpensePolicyPerDiemLocationId: number
    PerDiemLocationName: string
    EffectiveDate: Date | undefined
    IsDefault: boolean
}

export interface AccountExpensePolicyPerDiemIdClass {
    AccountExpensePolicyPerDiemId: number
}

export const expensePolicyPerDiemInitialsForAdd = {
    AccountExpensePolicyPerDiemId: "",
    AccountExpensePolicyId: "",
    DefaultExpenseCategoryPerDiemId: "",
    IsDisabledPerDiem: false,
    AccountExpensePolicyPerDiemLocationId: "",
    AccountExpensePolicyPerDiemLocationRateId: "",
    PerDiemLocationName: "",
    SystemCountryId: 0,
    CurrencyCode:'',
    SystemCityId: '',
    EffectiveDate: new Date(),
    IsDefaultRate: false,
    SystemCurrencyId: '',
    AccountExpensePolicyPerDiemTypeId: 0,
    AccountExpensePolicyPerDiemTypeName: '',
    PerDiemRate: 0,
    IsDefault: false,
    AccountExpenseId: 0,
    AccountExpenseName: ''
}


export const expensePolicyPerDiemInitialsForUpdate = {
    AccountExpensePolicyPerDiemId: "",
    AccountExpensePolicyId: "",
    DefaultExpenseCategoryPerDiemId: "",
    IsDisabledPerDiem: false,
    AccountExpensePolicyPerDiemLocationId: "",
    PerDiemLocationName: "",
    SystemCountryId: '',
    SystemCityId: '',
    EffectiveDate: new Date(),
    IsDefaultRate: false,
    SystemCurrencyId: '',
    AccountExpensePolicyPerDiemLocationRateId: "",
    AccountExpensePolicyPerDiemTypeId: 0,
    AccountExpensePolicyPerDiemTypeName: '',
    PerDiemRate: 0,
    IsDefault: false,
    AccountExpenseId: 0,
    AccountExpenseName: '',
    CurrencyCode:'',
    Country: '',
    City: ''
}

